<ng-container *ngIf="datos.tipo=='NoStatusVisi'">
  <h2 mat-dialog-title> {{'WEB_COMPANY_PROFILE.MODAL.TIT_MOD' | translate}}</h2>
  <mat-dialog-content class="mat-typography">

    <div fxLayout="column" fxLayoutAlign="start stretch">
      <mat-form-field appearance="outline">
        <!-- <mat-label>Texto</mat-label> -->
        <input matInput type="text" [(ngModel)]="raisonText">
        <!-- <input matInput type="text" [(ngModel)]="datos.info.ManualAudit_AuditorName"> -->
        <!-- <mat-icon matSuffix class="secondary-text">person</mat-icon> -->
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()" >
      {{'WEB_COMPANY_PROFILE.MODAL.BTN_CANC' | translate}}
      <mat-icon class="ml-20">arrow_back</mat-icon>
    </button>
    <button mat-raised-button color="primary" class="mt-20 dialog_confirmar" (click)="updateStatusNoPublicWebComProfile()" >
      {{'WEB_COMPANY_PROFILE.MODAL.BTN_CONT' | translate}}
      <mat-icon class="ml-20">save</mat-icon>
    </button>
  </div>
</ng-container>
<ng-container *ngIf="datos.tipo=='StatusVisi'">
  <h2 mat-dialog-title>{{'WEB_COMPANY_PROFILE.MODAL.TIT_CONDI_US' | translate}}</h2>
<mat-dialog-content class="mat-typography" style="height:30%!important">
<p>{{'WEB_COMPANY_PROFILE.MODAL.TEX1_CONDI_US' | translate}}</p>
<p>{{'WEB_COMPANY_PROFILE.MODAL.TEX2_CONDI_US' | translate}}</p>
<p>{{'WEB_COMPANY_PROFILE.MODAL.TEX3_CONDI_US' | translate}}</p>
<p>{{'WEB_COMPANY_PROFILE.MODAL.TEX4_CONDI_US' | translate}}</p>
</mat-dialog-content>

<h3>{{'WEB_COMPANY_PROFILE.MODAL.REA_TEX_CONDI_US' | translate}}</h3>

<h1 class="block-copy">{{ramdomCodigo}}</h1>

<mat-form-field appearance="outline">
  <input matInput type="text" [(ngModel)]="ramdomText">
</mat-form-field>


<mat-dialog-actions align="end">
  <button mat-button (click)="salir()">{{'WEB_COMPANY_PROFILE.MODAL.BTN_CANC' | translate}}
    <mat-icon class="ml-20">arrow_back</mat-icon>
  </button>
  <button mat-button  cdkFocusInitial (click)="updateStatusPublicWebComProfile()">{{'WEB_COMPANY_PROFILE.MODAL.BTN_CONT' | translate}}
  <mat-icon class="ml-20">save</mat-icon></button>
</mat-dialog-actions>
</ng-container>
<ng-container *ngIf="datos.tipo=='infoAcce'">
  <h2 mat-dialog-title>{{'WEB_COMPANY_PROFILE.TIT_WCP_DAT' | translate}}</h2>
  <mat-dialog-content class="mat-typography">
        <!-- <p>{{'COLABORADORES.ACCIONESUSUARIO.SUBTITULO' | translate}} {{datos.datosColab.name}}</p> -->
          <mat-list>
            <mat-list-item *ngFor="let accion of acciones; last as last" class="mt">
              <div class="" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
              <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
              <h4 mat-line>{{'WEB_COMPANY_PROFILE.' + accion.id | translate}}</h4>
              </div>
              <button mat-mini-fab color="primary" class="m-5" [disabled]="accion.bloqueado" (click)="this[accion.funcion]()">
                <mat-icon>{{accion.icono}}</mat-icon>
              </button>
            </div>
              <mat-divider [inset]="true" ></mat-divider>
            </mat-list-item>
          </mat-list>

  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-button (click)="salir()">{{'WEB_COMPANY_PROFILE.MODAL.BTN_CANC' | translate}}<mat-icon class="ml-20">arrow_back</mat-icon></button>
  </div>
</ng-container>
<ng-container *ngIf="datos.tipo=='helpVideo'">
<video src="https://drive.google.com/file/d/1Hx_I3OhBj9y4UBsA6T0yYCEM0KCC2aP2/view?usp=sharing" autoplay  style="width:50%;" controlslist="nodownload" ></video>
</ng-container>
